var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import * as Either from "fp-ts/lib/Either";
import { config, content, Env } from "core/utils";
import { View as Playlist } from "./View";
export var Provider = function (_a) {
    var myChannelsPlaylist = _a.myChannelsPlaylist, playerConfig = _a.playerConfig, className = _a.className;
    var _b = useState(null), html = _b[0], setHtml = _b[1];
    useEffect(function () {
        var controller = null;
        if (Env.isClient && html === null) {
            controller = new AbortController();
            (function () { return __awaiter(void 0, void 0, Promise, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetchPlaylist(myChannelsPlaylist, playerConfig, controller.signal)];
                        case 1:
                            result = _a.sent();
                            if (Either.isLeft(result)) {
                                if (result.left.kind !== "Abort") {
                                    setHtml("Error: ".concat(result.left.message));
                                }
                            }
                            else {
                                setHtml(result.right);
                            }
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
        /**
         * Cleanup for fetchRequest
         */
        return function () {
            if (controller)
                controller.abort();
        };
    }, []);
    return html !== null ? (React.createElement(Playlist, { className: className, html: html, titleFlag: playerConfig.titleFlag })) : null;
};
function fetchPlaylist(myChannelsPlaylist, playerConfig, signal) {
    return __awaiter(this, void 0, Promise, function () {
        var configId, playlistData, e_1, json, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    configId = getMyChannelsConfigId(playerConfig);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(config.urls.myChannelsPlaylistEmbedApi(myChannelsPlaylist, configId), {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Token ".concat(config.myChannelsApiKey),
                            },
                            signal: signal,
                        })];
                case 2:
                    playlistData = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    return [2 /*return*/, Either.left({ kind: "Abort" })];
                case 4:
                    _a.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, playlistData.json()];
                case 5:
                    json = _a.sent();
                    return [3 /*break*/, 7];
                case 6:
                    e_2 = _a.sent();
                    return [2 /*return*/, Either.left({ kind: "Regular", message: content.playerDataNoJson })];
                case 7:
                    if (typeof json === "undefined") {
                        return [2 /*return*/, Either.left({ kind: "Regular", message: content.noPlayerData })];
                    }
                    if (typeof json.html === "undefined") {
                        return [2 /*return*/, Either.left({ kind: "Regular", message: content.noPlayerHtml })];
                    }
                    return [2 /*return*/, Either.right(json.html)];
            }
        });
    });
}
export function booleanToMyChannelsValue(option) {
    return option ? "T" : "F";
}
/**
 * Config ID is based on true/false/undefined values for config params.
 * More info: https://embed-api.mychannels.video/v3/docs/index.html#/Embed%20Production/VaasEmbedApi_V3_EmbedsController_show
 */
export function getMyChannelsConfigId(playerConfig) {
    var configList = [
        playerConfig.autoplay,
        playerConfig.automute,
        playerConfig.single_play,
        playerConfig.pip,
        playerConfig.sticky,
    ];
    return configList.map(function (option) { return booleanToMyChannelsValue(option); }).join("");
}
